import gql from 'graphql-tag';
export default gql`
  mutation DeletePhoneById($input: DeletePhoneByIdInput!) {
    deletePhoneById(input: $input) {
      deletedPhoneId
    }
  }
`;
